// extracted by mini-css-extract-plugin
export default {"tab":"Chart_tab__WNtq7"};